import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Forwarder from '@SiteContainers/Forwarder'
import LabelsTable from '@SiteContainers/LabelsTable'
import CreateLabelPopup from '@SiteContainers/CreateLabelPopup'
import RenameLabelPopup from '@SiteContainers/RenameLabelPopup/RenameLabelPopup'
import DeleteLabelPopup from '@SiteContainers/DeleteLabelPopup/DeleteLabelPopup'
import Sidebar from '@SiteContainers/Sidebar'

import {
  fetchLabels,
} from '@SiteModules/Label/actions'

import {
  closeLabelPopups,
} from '@SiteModules/Popup/actions'

import {
  getCurrentWorkspaceId,
} from '@SiteModules/Workspace/selectors'

import {
  getHasLoadedInitially,
} from '@SiteModules/Label/selectors'

import {
  getCreateLabelPopupIsOpen,
  getDeleteLabelPopupIsOpen,
  getRenameLabelPopupIsOpen,
} from '@SiteModules/Popup/selectors'

import './Labels.scss'

const Labels: React.FC = () => {
  const dispatch = useDispatch()

  const currentWorkspaceId = useSelector(getCurrentWorkspaceId)
  const createLabelPopupIsOpen = useSelector(getCreateLabelPopupIsOpen)
  const deleteLabelPopupIsOpen = useSelector(getDeleteLabelPopupIsOpen)
  const renameLabelPopupIsOpen = useSelector(getRenameLabelPopupIsOpen)
  const hasLoadedInitially = useSelector(getHasLoadedInitially)

  useEffect(() => {
    if (currentWorkspaceId >= 0 && !hasLoadedInitially) {
      dispatch(fetchLabels({ workspaceId: currentWorkspaceId }))
    }
  } , [currentWorkspaceId, hasLoadedInitially])

  const handleCloseLabelPopups = () => {
    dispatch(closeLabelPopups())
  }

  const renderLabels = () => {
    return (
      <div
        className="Labels"
        id="labels"
      >
        <Sidebar
          pageName="labels"
        />
        <LabelsTable />
        {renderPopups()}
      </div>
    )
  }

  const renderPopups = () => {
    return (
      <React.Fragment>
        {createLabelPopupIsOpen && renderCreateLabelPopup()}
        {deleteLabelPopupIsOpen && renderDeleteLabelPopup()}
        {renameLabelPopupIsOpen && renderRenameLabelPopup()}
      </React.Fragment>
    )
  }

  const renderCreateLabelPopup = () => {
    return (
      <CreateLabelPopup
        closePopup={handleCloseLabelPopups}
      />
    )
  }

  const renderDeleteLabelPopup = () => {
    return (
      <DeleteLabelPopup
        closePopup={handleCloseLabelPopups}
      />
    )
  }

  const renderRenameLabelPopup = () => {
    return (
      <RenameLabelPopup
        closePopup={handleCloseLabelPopups}
      />
    )
  }

  return (
    <React.Fragment>
      <Forwarder />
      {renderLabels()}
    </React.Fragment>
  )
}

export default Labels
